<template>
  <v-app style="height: 100%;" :class="isDefaultMode ? 'bg-primary' : ''">
    <v-alert
      v-if="activePage !== 'splash' && info.top_banner && info.top_banner.length > 2"
      dense color="primary" class="text-center pa-2 text-error"
    >
      {{ info.top_banner }}
    </v-alert>

    <!-- هدر ثابت — فقط صفحات داخلی؛ splash هدر نداره، toggle خودش رو شناور داره -->
    <div v-if="activePage !== 'splash'" class="default-header" :class="isDefaultMode ? 'default-header-onprimary' : ''">
      <div class="default-header-inner">
        <v-btn icon="mdi-arrow-right" variant="text" @click="$store.commit('setActivePage', backTarget)"></v-btn>
        <h3 class="flex-grow-1 text-center" style="font-size:16px;">{{ info.direct_title }}</h3>

        <v-menu location="bottom end" :close-on-content-click="true">
          <template #activator="{ props }">
            <v-btn v-bind="props" :icon="themeModeIcon" variant="text" size="small" />
          </template>
          <v-list density="compact" min-width="140" rounded="lg">
            <v-list-item
              v-for="item in themeModes" :key="item.value"
              :prepend-icon="item.icon" :title="item.label"
              :active="themeMode === item.value"
              @click="$store.commit('setThemeMode', item.value)"
            />
          </v-list>
        </v-menu>

        <v-btn v-if="$store.getters.getAuthToken == ''" :disabled="baseLoading" variant="outlined" @click="$store.commit('setLoginDialogStatus', true)">
          {{ $t('booking.login_button') }}
        </v-btn>
        <v-menu v-else>
          <template #activator="{ props }">
            <v-btn v-bind="props" icon="mdi-account" variant="text"></v-btn>
          </template>
          <v-list class="text-center">
            <v-list-item>{{ $t('booking.welcome_message', { mobile: $store.state.mobile }) }}</v-list-item>
            <v-list-item @click="$store.commit('setActivePage', 'orders_history')">لیست سفارشات</v-list-item>
            <v-list-item @click="$store.dispatch('logout')" class="text-red">{{ $t('booking.logout_button') }}</v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-main>
      <slot />
    </v-main>

    <slot name="dialogs" />

    <!-- splash هدر ندارد؛ toggle شناور همینجا -->
    <div v-if="activePage === 'splash'" style="position: fixed; bottom: 16px; left: 16px; z-index: 999;">
      <v-menu location="top start" :close-on-content-click="true">
        <template #activator="{ props }">
          <v-btn v-bind="props" :icon="themeModeIcon" variant="tonal" size="small" />
        </template>
        <v-list density="compact" min-width="140" rounded="lg">
          <v-list-item
            v-for="item in themeModes" :key="item.value"
            :prepend-icon="item.icon" :title="item.label"
            :active="themeMode === item.value"
            @click="$store.commit('setThemeMode', item.value)"
          />
        </v-list>
      </v-menu>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'DefaultLayout',
  data: () => ({
    themeModes: [
      { value: 'default', label: 'پیش‌فرض', icon: 'mdi-palette' },
      { value: 'light',   label: 'روشن',    icon: 'mdi-weather-sunny' },
      { value: 'dark',    label: 'تاریک',   icon: 'mdi-weather-night' },
    ],
  }),
  computed: {
    activePage()    { return this.$store.state.activePage; },
    info()          { return this.$store.state.info; },
    baseLoading()   { return this.$store.state.baseLoading; },
    themeMode()     { return this.$store.state.themeMode; },
    isDefaultMode() { return this.themeMode === 'default'; },
    themeModeIcon() {
      return {
        default: 'mdi-palette',
        light:   'mdi-weather-sunny',
        dark:    'mdi-weather-night',
      }[this.themeMode] ?? 'mdi-palette';
    },
    backTarget() {
      const map = { booking: 'splash', order: 'booking', orders_history: 'booking', order_detail: 'orders_history' };
      return map[this.activePage] ?? 'splash';
    },
  },
};
</script>

<style scoped>
.default-header { background: rgb(var(--v-theme-surface)); border-bottom: 1px solid rgba(var(--v-theme-on-surface), .08); }
.default-header-onprimary { background: rgb(var(--v-theme-primary)); color: rgb(var(--v-theme-on-primary)); }
.default-header-inner { max-width: 600px; margin: 0 auto; display: flex; align-items: center; gap: 4px; padding: 4px 8px; }
</style>
